import * as React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ROLE } from '../core/auth/role.constant';

interface Props {
    role: string;
}

const FournisseurChauffeurRoute = ({ role }: Props) => {
    const location = useLocation();
    // TODO - change role to fournisseur , accept role Client for testing facility
    return role === ROLE.CHAUFFEUR || role === ROLE.FOURNISSEUR ? <Outlet /> : <Navigate replace to="/" state={{ from: location }} />;
};

export default FournisseurChauffeurRoute;
